import { apiClient, assertValidParam } from '@v2/lib';
import type { Instance, ClientManifest } from '@v2/types';

export const instancesService = {
  getInstances: async (): Promise<Instance[]> => {
    const response = await apiClient().get<Instance[]>('instances');
    return Array.isArray(response.data) ? response.data : [];
  },

  getClientManifest: async (instanceId: string): Promise<ClientManifest | null> => {
    const safeId = assertValidParam(instanceId, 'instanceId');
    const response = await apiClient().get<ClientManifest>(`ClientManifest/${safeId}`);
    return response.data ?? null;
  },
};
